import { Link } from 'react-router-dom';

// material-ui
import { ButtonBase } from '@mui/material';
import { useTheme } from '@mui/material/styles';

// project imports
import config from 'config';
import Logo from 'ui-component/Logo';

import logoSistema from '../../../assets/images/Secondary_No_Slogan.png'

// ==============================|| MAIN LOGO ||============================== //

const LogoSection = () => {
    const theme = useTheme();

    return (
        <ButtonBase sx={{ color: theme.palette.primary.main }} disableRipple component={Link} to={config.defaultPath}>
            {/* <Logo */}
            <img src={logoSistema} alt="Kmillion - Promotional Intelligence" width="160" valign={"center"} />
        </ButtonBase>
    );
};

export default LogoSection;
